module.exports = __webpack_public_path__ + "img/z_tg.ea278b0a.png";